import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import BenefitsSection from "./components/BenefitsSection";
import OfferingsSection from "./components/OfferingsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import TrustSection from "./components/TrustSection";
import AboutSection from "./components/AboutSection";
import BlogSection from "./components/BlogSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import MapSection from "./components/MapSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <main role="main" itemScope itemType="https://schema.org/WebPage">
        <HeroSection />
        <ServicesSection />
        <BenefitsSection />
        <OfferingsSection />
        <WhyChooseSection />
        <TrustSection />
        <AboutSection />
        <BlogSection />
        <FAQSection />
        <CTASection />
        <ContactSection />
        <MapSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App" lang="ro">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
